import { render, staticRenderFns } from "./DrugExcess.vue?vue&type=template&id=453f4f0c&scoped=true"
import script from "./DrugExcess.vue?vue&type=script&lang=js"
export * from "./DrugExcess.vue?vue&type=script&lang=js"
import style0 from "./DrugExcess.vue?vue&type=style&index=0&id=453f4f0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453f4f0c",
  null
  
)

export default component.exports